<form snDrawer (ngSubmit)="onFormSubmit()">
  <sn-drawer-header [title]="'shares.configShare' | t">
    <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
    <sn-drawer-header-actions>
      <sn-flat-button color="success" type="submit" [disabled]="form.invalid">{{ 'common.save' | t }}</sn-flat-button>
    </sn-drawer-header-actions>
  </sn-drawer-header>

  <sn-share-details [share]="share"></sn-share-details>

  <sn-drawer-content indented>
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </sn-drawer-content>
</form>
